import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AddonService } from 'src/app/services/core/addons/addon.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-add-addon',
  templateUrl: './add-addon.component.html',
  styleUrls: ['./add-addon.component.css']
})
export class AddAddonComponent implements OnInit {

  addonsForm!: FormGroup;
  addonId: any;
  submitted = false;
  // Edit Modal Inputs and Outputs
  @Input() addons: any;
  @Input() source: any;
  @Output() onSaveAddons = new EventEmitter<string>();
  @Output() onCloseModal = new EventEmitter<string>();
  // Edit Modal Inputs and Outputs End

  constructor(private fb: FormBuilder, private route: ActivatedRoute, private router: Router, private addonService: AddonService) {

  }

  ngOnInit() {
    if (this.source === 'modal' && this.addons) {
      this.addonId = this.addons.id;
      this.getAddonById();
    } else {
      this.addonId = this.route.snapshot.params['addonId'];
      if (this.addonId) {
        this.getAddonById();
      }
    }

    this.addonsForm = this.fb.group({
      title: ['', Validators.required],
      code: ['', Validators.required],
      fare: ['', Validators.required],
      description: ['', Validators.required],
      isActive: [true, Validators.required],
      type: ['fixed'],
      isPrivateOnly: [false],
      isDiscount: [false],
      isCreditCardFee: [false]
    })
  }

  onSave() {
    this.submitted = true;
    if (this.addonsForm.invalid) {
      return;
    }
  
    const payload = { ...this.addonsForm.value };
  
    // If description is empty, set it to null or a default value
    if (!payload.description) {
      payload.description = null; // or 'No description'
    }
  
    this.addonService.saveAddons(this.addonId, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        if (this.source === 'modal') {
          this.onSaveAddons.emit(data);
        } else {
          this.router.navigateByUrl('configurations/addons');
        }
        
      }
    },
      (err) => {
        sweetAlert("Error", "Please enter a valid number in the 'Rate' field.", "error", "OK");
      }
    );
  }
  

  get form() {
    return this.addonsForm.controls;
  }

  getAddonById() {
    this.addonService.getAddonById(this.addonId).pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.addonsForm.patchValue({
          ...data
        });
      }
    })
  }

  togglePrivateOnly(event:Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.addonsForm.patchValue({
      isPrivateOnly: isChecked,
    });
  }

  
  toggleCreditCardFee(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.addonsForm.patchValue({
      isCreditCardFee: isChecked,
      applyOnOverall: false,
      isDiscount: false
    });
  }
  toggleDiscount(event:Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.addonsForm.patchValue({
      isDiscount: isChecked,
      isCreditCardFee: false,
      applyOnOverall: false
    });
  }
}
